import Head from 'next/head';
import '../styles/globals.css';
import { ToastProvider } from '../stores/ToastContext';
import { AuthProvider } from '../stores/AuthContext';
import { useRouter } from 'next/router';
import * as Sentry from '@sentry/nextjs';
import { setToken } from '../util/tokenManager';

const DSN = 'https://b33a9d02d9e7ba69921d4a30bdec9c89@sentry.duetapp.net/2';
const noReplayPaths = [];
const appTitle = 'Duet';
const iconHref = '/favicon.ico';
const imageUrl = 'https://cdn.duetapp.net/v1/images/eyJpZCI6IkdDTTNFUTY2M1hNQU1EREZEQ0pVUE0zR0lFS1pTSCIsInciOjcyLCJoIjo3MiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEyODQ4MTA4NzUyNTQxNjAzMjQyLCJhYiI6MH0?format=originalOFGHLERTH';


const remPath = ['/account', '/wing/account', '/logEntries/[method]', '/wing/logEntries/[method]', '/questionnaire', '/playground_mobile', '/'];
const pixelTikTok = `<!-- TikTok Pixel Code -->
!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


  ttq.load('CV8ETFJC77U13TBVPEU0');
  ttq.page();
}(window, document, 'ttq');
<!-- End TikTok Pixel Code -->`;


function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const styleText = remPath.includes(router.pathname) ? `html {
    font-size: calc(100vw / 3.75) !important;
  }` : '';

  // 客户端渲染 存储服务端传过来的access-token
  if (typeof window !== 'undefined' && pageProps.accessToken) {
    setToken(pageProps.accessToken);
  }

  if (!Sentry.getCurrentHub().getClient() && typeof window !== 'undefined') {
    const isLowSampleRate = noReplayPaths.includes(router.route);
    Sentry.init({
      environment: pageProps.nodeEnv,
      dsn: DSN,
      // 上报浏览器页面渲染指标
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          networkDetailAllowUrls: [window.location.origin],
          networkRequestHeaders: ['Authorization'],
        }),
      ],
      tracesSampleRate: isLowSampleRate ? 0.1 : 1,
      replaysSessionSampleRate: isLowSampleRate ? 0.1 : 1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  if (router.pathname === '/welcome/[gender]' && typeof window !== 'undefined') {
    eval(pixelTikTok);
  }

  return (
    <>
      <Head>
        {/* 默认配置 */}
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover"
        />

        {/* 标题图标 */}
        <link rel="icon" type="image/x-icon" href={iconHref} />

        {/* Google认证 ,wing先不加 */}
        { <meta name="google-site-verification" content="4Gna40o8rIPOJbXNPxzISl0pEveNd46RTQ6QDmufIDg" />
}
        {/* 基本标签, 第一种方法渲染时候会出现注释 */}
        <meta
          name="description"
          content={`${appTitle} is a dating application helps you find meaningful relationships based on shared interests and experiences.`}
        />
        <meta
          property="og:image"
          content={imageUrl}
        />

        {/* Open Graph */}
        <meta property="og:title" content={`${appTitle} | Meet People You Resonate With`} />
        <meta
          property="og:description"
          key="description"
          content={`${appTitle} is a dating application helps you find meaningful relationships based on shared interests and experiences.`}
        />
        <meta
          property="og:image"
          content={imageUrl}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://duetapp.net/" />

        {/* Twitter Card */}
        <meta name="twitter:title" content={`${appTitle} | Meet People You Resonate With`} />
        <meta
          name="twitter:description"
          content={`${appTitle} is a dating application helps you find meaningful relationships based on shared interests and experiences.`}
        />
        <meta
          name="twitter:image"
          content={imageUrl}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <style>{styleText}</style>
      </Head>
      <AuthProvider>
        <ToastProvider>
          <Component {...pageProps} />
        </ToastProvider>
      </AuthProvider>
    </>
  );
}

export default MyApp;
